import RestClient from '../../../../api/axiosInterceptor';
import { passwordActions } from '../../../actions/user/pharmacy/Account/resetPassword';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    // Dispatch the request action before making the API call
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();

    // Dispatch the success action with the response data
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-right' });
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'An error occurred. Please try again.';

    // Dispatch the failure action with the error message
    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-right' });
  }
};

// Request Password Reset Action
export const pharmacyRequestPasswordReset = (email) =>
  createAsyncAction(
    passwordActions.RESET_PASSWORD,
    () => RestClient.post('/pharmacy/reset-password-request/', { email })
  );

// Confirm Password Reset Action
export const pharmacyConfirmPasswordReset = (token, newPassword) =>
  createAsyncAction(
    passwordActions.CONFIRM_RESET_PASSWORD,
    () => RestClient.post('/pharmacy/reset-password/', { token, new_password: newPassword })
  );
